import { render } from "./PageToeDemo.vue?vue&type=template&id=7104c344"
import script from "./PageToeDemo.vue?vue&type=script&lang=js"
export * from "./PageToeDemo.vue?vue&type=script&lang=js"

import "./PageToeDemo.vue?vue&type=style&index=0&id=7104c344&lang=scss"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__